import { createAction } from '@reduxjs/toolkit'

import type { GetExercisesRequestSuccess } from './types'

export const getExercisesRequest = createAction('GET_EXERCISES_REQUEST')
export const getExercisesSuccess = createAction<GetExercisesRequestSuccess>(
  'GET_EXERCISES_SUCCESS'
)
export const getExercisesFailed = createAction('GET_EXERCISES_FAILED')
